
const Status = {
  NotInitialized: 'non-init',
  Local: 'local',
  Session: 'session',
  None: 'none',
};

export class BrowserStorage {
  status = Status.NotInitialized;
  storage = null;

  getItem(path) {
    return this.tryAccess((storage) => storage.getItem([path]));
  }

  setItem(path, value) {
    return this.tryAccess((storage) => storage.setItem(path, value));
  }

  removeItem(path) {
    return this.tryAccess((storage) => storage.removeItem(path));
  }

  tryAccess(callback) {
    if (this.status === Status.None) {
      return null;
    }

    try {
      if (!this.storage) {
        switch (this.status) {
          case Status.NotInitialized: {
            this.status = Status.Local;
            this.storage = window.localStorage;
          }; break;
  
          case Status.Local: {
            this.status = Status.Session;
            this.storage = window.sessionStorage;
          }; break;

          case Status.Session: {
            this.status = Status.None;
            return null;
          };
        }
      }
      
      return callback(this.storage);
    }
    catch (e) {
      return this.tryAccess(callback);
    }
  }
};